/**
 * Fetch videos by category via AJAX
 * @returns {Promise<string|null>} HTML content or null on error
 */
export async function fetchVideosByCategory(category = '') {
	const formData = new FormData();
	formData.append('action', 'wpcore_get_videos');
	formData.append('nonce', wpcore.nonce);
	formData.append('category', category);

	try {
		const response = await fetch(wpcore.ajaxUrl, {
			method: 'POST',
			body: formData
		});
		const data = await response.json();

		if (data.success) {
			return data.data.html || '';
		}
		return null;
	} catch (error) {
		console.error('Error fetching videos:', error);
		return null;
	}
}

/**
 * Assign videos to stage via AJAX
 * @returns {Promise<boolean>} Success status
 */
export async function assignVideo(stageId, videoIds) {
	const formData = new FormData();
	formData.append('action', 'wpcore_assign_videos_to_stage');
	formData.append('nonce', wpcore.nonce);
	formData.append('stage_id', stageId);

	videoIds.forEach(id => {
		formData.append('video_ids[]', id);
	});

	try {
		const response = await fetch(wpcore.ajaxUrl, {
			method: 'POST',
			body: formData
		});
		const data = await response.json();

		if (!data.success) {
			console.error('Error:', data.data?.message);
		}

		return data.success;
	} catch (error) {
		console.error('Error:', error);
		return false;
	}
}

/**
 * Fetch stage videos via AJAX
 * @returns {Promise<Array>} Array of video objects
 */
export async function fetchStageVideos(stageId) {
	const formData = new FormData();
	formData.append('action', 'wpcore_get_stage_videos');
	formData.append('nonce', wpcore.nonce);
	formData.append('stage_id', stageId);

	try {
		const response = await fetch(wpcore.ajaxUrl, {
			method: 'POST',
			body: formData
		});
		const data = await response.json();

		if (data.success) {
			return data.data.videos || [];
		}
		return [];
	} catch (error) {
		console.error('Error:', error);
		return [];
	}
}
